/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as SettingsLanguageRouteImport } from './routes/settings/language'
import { Route as SettingsPriceRouteImport } from './routes/settings/price'
import { Route as SettingsProductRouteImport } from './routes/settings/product'
import { Route as WidgetIndexRouteImport } from './routes/widget/index'
import { Route as WidgetCartRouteImport } from './routes/widget/cart'
import { Route as WidgetCheckoutRouteImport } from './routes/widget/checkout'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsLanguageRoute = SettingsLanguageRouteImport.update({
  id: '/language',
  path: '/language',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsPriceRoute = SettingsPriceRouteImport.update({
  id: '/price',
  path: '/price',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsProductRoute = SettingsProductRouteImport.update({
  id: '/product',
  path: '/product',
  getParentRoute: () => SettingsRoute,
} as any)
const WidgetIndexRoute = WidgetIndexRouteImport.update({
  id: '/widget/',
  path: '/widget/',
  getParentRoute: () => rootRouteImport,
} as any)
const WidgetCartRoute = WidgetCartRouteImport.update({
  id: '/widget/cart',
  path: '/widget/cart',
  getParentRoute: () => rootRouteImport,
} as any)
const WidgetCheckoutRoute = WidgetCheckoutRouteImport.update({
  id: '/widget/checkout',
  path: '/widget/checkout',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/settings': typeof SettingsRouteWithChildren
  '/settings/language': typeof SettingsLanguageRoute
  '/settings/price': typeof SettingsPriceRoute
  '/settings/product': typeof SettingsProductRoute
  '/widget/cart': typeof WidgetCartRoute
  '/widget/checkout': typeof WidgetCheckoutRoute
  '/settings/': typeof SettingsIndexRoute
  '/widget/': typeof WidgetIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/settings/language': typeof SettingsLanguageRoute
  '/settings/price': typeof SettingsPriceRoute
  '/settings/product': typeof SettingsProductRoute
  '/widget/cart': typeof WidgetCartRoute
  '/widget/checkout': typeof WidgetCheckoutRoute
  '/settings': typeof SettingsIndexRoute
  '/widget': typeof WidgetIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/settings': typeof SettingsRouteWithChildren
  '/settings/language': typeof SettingsLanguageRoute
  '/settings/price': typeof SettingsPriceRoute
  '/settings/product': typeof SettingsProductRoute
  '/widget/cart': typeof WidgetCartRoute
  '/widget/checkout': typeof WidgetCheckoutRoute
  '/settings/': typeof SettingsIndexRoute
  '/widget/': typeof WidgetIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/settings'
    | '/settings/language'
    | '/settings/price'
    | '/settings/product'
    | '/widget/cart'
    | '/widget/checkout'
    | '/settings/'
    | '/widget/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/settings/language'
    | '/settings/price'
    | '/settings/product'
    | '/widget/cart'
    | '/widget/checkout'
    | '/settings'
    | '/widget'
  id:
    | '__root__'
    | '/'
    | '/settings'
    | '/settings/language'
    | '/settings/price'
    | '/settings/product'
    | '/widget/cart'
    | '/widget/checkout'
    | '/settings/'
    | '/widget/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  WidgetCartRoute: typeof WidgetCartRoute
  WidgetCheckoutRoute: typeof WidgetCheckoutRoute
  WidgetIndexRoute: typeof WidgetIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/language': {
      id: '/settings/language'
      path: '/language'
      fullPath: '/settings/language'
      preLoaderRoute: typeof SettingsLanguageRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/price': {
      id: '/settings/price'
      path: '/price'
      fullPath: '/settings/price'
      preLoaderRoute: typeof SettingsPriceRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/product': {
      id: '/settings/product'
      path: '/product'
      fullPath: '/settings/product'
      preLoaderRoute: typeof SettingsProductRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/widget/': {
      id: '/widget/'
      path: '/widget'
      fullPath: '/widget/'
      preLoaderRoute: typeof WidgetIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/widget/cart': {
      id: '/widget/cart'
      path: '/widget/cart'
      fullPath: '/widget/cart'
      preLoaderRoute: typeof WidgetCartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/widget/checkout': {
      id: '/widget/checkout'
      path: '/widget/checkout'
      fullPath: '/widget/checkout'
      preLoaderRoute: typeof WidgetCheckoutRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface SettingsRouteChildren {
  SettingsLanguageRoute: typeof SettingsLanguageRoute
  SettingsPriceRoute: typeof SettingsPriceRoute
  SettingsProductRoute: typeof SettingsProductRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsLanguageRoute: SettingsLanguageRoute,
  SettingsPriceRoute: SettingsPriceRoute,
  SettingsProductRoute: SettingsProductRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SettingsRoute: SettingsRouteWithChildren,
  WidgetCartRoute: WidgetCartRoute,
  WidgetCheckoutRoute: WidgetCheckoutRoute,
  WidgetIndexRoute: WidgetIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
